export const alphaSort =
  <T>(picker: (item: T) => string = (item) => item as any, reverse?: boolean) =>
  (a: T, b: T) => {
    // Empty values go last
    if (!a) {
      return reverse ? -1 : 1;
    }
    if (!b) {
      return reverse ? 1 : -1;
    }

    const A = (picker(a) || '').toLowerCase();
    const B = (picker(b) || '').toLowerCase();

    // Empty values go last
    if (!A) {
      return reverse ? -1 : 1;
    }
    if (!B) {
      return reverse ? 1 : -1;
    }

    if (A < B) {
      return reverse ? 1 : -1;
    }
    if (A > B) {
      return reverse ? -1 : 1;
    }
    return 0;
  };

export const alphaSorter = alphaSort<string>();
